import styled from 'styled-components';

interface ColumnProps {
	width?: string;
}

export const TableContainer = styled.table`
	width: 100%;
	border-collapse: collapse;
`;

export const TableHeader = styled.thead`
	text-align: left;
`;

export const TableBody = styled.tbody``;

export const TableHeaderCell = styled.th<ColumnProps>`
	padding: 16px 8px;
	width: ${({ width }) => width || 'auto'};
	border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.grey};

	&:hover {
		cursor: pointer;
		color: ${({ theme }) => theme.colors.primary.medium};
	}
`;

export const TableRow = styled.tr``;

export const TableCell = styled.td`
	padding: 8px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.grey};
	font-size: 14px;
`;

export const ExportButtons = styled.div`
	float: right;
	position: sticky;
	bottom: 0;
	background-color: ${({ theme }) => theme.colors.neutral.white};
	border-top: 1px solid ${({ theme }) => theme.colors.neutral.grey};
	display: flex;
	gap: 20px;
	padding: 16px;
`;

export const ReportHeaderContainer = styled.div`
	display: none;
	margin-top: 30px;
	text-align: center;
`;

export const PaginationContainer = styled.div`
	display: flex;
	justify-content: center;
	gap: 8px;
	margin-top: 20px;
`;

export const HeaderContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;
